module.exports = __webpack_public_path__ + "static/media/IMG_2180.2f9a8ea0.jpg";